import React, { useState } from 'react';
import styled from '@emotion/styled';

import { useMediaQuery } from '../../../../../util/useMediaQuery'
import HamburgerMenu from '../_atoms/HamburgerMenu';
import Brand from './Brand/index';
import PrimaryNavLinks from './PrimaryNavLinks/index';
import SecondaryNavLinks from './SecondaryNavLinks/index';
import TinyTopNav from './TinyTopNav';

export const PrimaryNavContainer = styled.div`
  display: flex;
  padding: 0;
  align-items: center;
  margin-left: 40px;
  margin-top: 4px;
  margin-bottom: -1px;
  color: 'hsl(221, 93%, 16%)';
  z-index: 20;

  @media screen and (max-width: 1023px) {
    margin-left: 5px;
    margin-top: 5px;
  }
`;

const StyledNav = styled.nav`
  top: 41px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  position: fixed;
  box-shadow: rgb(3 27 78 / 10%) 0px 2px 4px;
  background: #fff;
  align-items: center;
  width: 100vw;
  height: 64px;
  z-index: 1000;

  @media screen and (max-width: 1023px) {
    position: relative;
    top: 0px !important;
    justify-content: space-between;

    .hamburger {
      margin-right: 20px;
    }
  }

  .logo {
    flex: .15;
    color: var(--text);
    font-size: 32px;
  }
`;

export const SecondaryNavContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0;
`;

export const MobileContainer = styled.div`
  width: 80%;
  display: flex;
  position: absolute;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 8px 16px rgb(10 10 10 / 10%);
  padding: 2rem 0;

  @media screen and (max-width: 1023px) {
    left: 20px;
    top: 65px;
    width: 90%;
  }
`;

const Navigation = ({ data, location }) => {
  const { navigation } = data.prismic;

  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const isMobile = useMediaQuery('(max-width: 1023px)');

  const Desktop = ({ children }) => (isDesktop ? children : null);

  const Mobile = ({ children, display }) => (isMobile ? <div style={{ display }}>{children}</div> : null);

  return (
    <>
      <StyledNav>
        <TinyTopNav navigation={navigation} />
        {Brand(navigation)}
        <Desktop>
          <PrimaryNavContainer>{PrimaryNavLinks(navigation, location)}</PrimaryNavContainer>
          <SecondaryNavContainer>{SecondaryNavLinks(navigation)}</SecondaryNavContainer>
        </Desktop>
        <Mobile display={isMobileNavOpen ? 'block' : 'none'}>
          <MobileContainer>
            {PrimaryNavLinks(navigation, location)}
            {SecondaryNavLinks(navigation)}
          </MobileContainer>
        </Mobile>
        {isMobile && (
          <HamburgerMenu
            className="hamburger"
            color="#5b6987"
            width={20}
            height={16}
            isOpen={isMobileNavOpen}
            menuClicked={() => {
              setIsMobileNavOpen(!isMobileNavOpen);
            }}
          />
        )}
      </StyledNav>
    </>
  );
};

export default Navigation;
